export class UpdatePortfolioData {
	static readonly type = '[Portfolio] Update portfolio data';
}

export class UpdateDateRange {
	static readonly type = '[Portfolio] Update date range';
}

export class UpdateLatestData {
	static readonly type = '[Portfolio] Update latest data';
}

export class ResetPortfolioData {
	static readonly type = '[Portfolio] Reset portfolio data';
}
